import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { NbButton, NbInput } from "../components/nb";
import { Heart } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Account created! Verify your email to get a badge.");
      navigate("/profile");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grain flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center mb-6">
          <img src="/logo.png" alt="qrcupid" className="h-20 w-auto" />
        </Link>
        <div className="bg-white nb-border-thick nb-shadow-lg p-8">
          <h1 className="font-head font-black text-3xl tracking-tight mb-1">Create your QR</h1>
          <p className="text-gray-600 font-medium mb-6">It's free. Stand out at your next event.</p>
          {error && <div data-testid="register-error" className="bg-[#EF4444] text-white nb-border p-3 mb-4 text-sm font-bold">{error}</div>}
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="font-head font-bold text-sm uppercase">Name</label>
              <NbInput data-testid="register-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1" placeholder="Your name" />
            </div>
            <div>
              <label className="font-head font-bold text-sm uppercase">Email</label>
              <NbInput data-testid="register-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1" placeholder="you@example.com" />
            </div>
            <div>
              <label className="font-head font-bold text-sm uppercase">Password</label>
              <NbInput data-testid="register-password" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1" placeholder="Min 6 characters" />
            </div>
            <NbButton type="submit" data-testid="register-submit" disabled={loading} className="w-full">{loading ? "Creating..." : "Create Account"}</NbButton>
          </form>
          <p className="text-center text-sm font-medium mt-6">Already a member? <Link to="/login" className="font-bold text-[#8B1E3F] hover:underline">Log in</Link></p>
        </div>
      </div>
    </div>
  );
}
